export default "__VITE_ASSET__DvXhnJzt__"